/** @jsxImportSource theme-ui */
import FooterLogo from "./FooterLogo";
import FooterLink from "./FooterLink";
import Copyright from "./Copyright";
import { Box, Container, Flex, Paragraph } from "theme-ui";
import { Mail, MessageCircle, Phone } from "react-feather";

const Footer = ({ container = "container" }) => {
  return (
    <footer
      sx={{
        py: 10,
        display: "flex",
        flexDirection: ["column", null, "row"],
        justifyContent: ["center", null, "space-around"],
        alignItems: "center",
        bg: "#25252B",
      }}
    >
      <Container sx={{ pt: 0, m: 0 }} variant={container}>
        <Flex
          sx={{
            // width: "300px",
            display: "flex",
            // flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "space-between",
            flexWrap: ["wrap", null, "nowrap"],
          }}
        >
          <Box>
            <FooterLogo />
            <ul
              sx={{
                p: 0,
                mb: 0,
                display: "flex",
                listStyle: "none",
                li: {
                  whiteSpace: "nowrap",
                },
              }}
            >
              <li sx={{ pr: 4 }}>
                <FooterLink
                  url="/terms-and-conditions"
                  text="Terms &amp; Conditions"
                />
              </li>
              {/* <li>
                <FooterLink url="#" text="Privacy Policy" />
              </li> */}
            </ul>
            <Flex>
              <ul
                sx={{
                  listStyle: "none",
                  p: 0,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <li>
                  <a
                    href="tel:6028593048"
                    sx={{
                      variant: "links.footer",
                      textDecoration: "none",
                      mt: 1,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Phone size={16} sx={{ mr: 2 }} /> 602.859.3048
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:contact@bodycam.report"
                    sx={{
                      variant: "links.footer",
                      textDecoration: "none",
                      mt: 1,
                      ml: 4,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Mail size={16} sx={{ mr: 2 }} /> contact@bodycam.report
                  </a>
                </li>
              </ul>
            </Flex>
          </Box>
          <Copyright />
        </Flex>
      </Container>
    </footer>
  );
};

export default Footer;
